import Cookies from 'js-cookie'

const unionKey = 'vue_typescript_admin_access_token'
const routeName = 'anyName'
export const getId = () => Cookies.get(unionKey)
export const setId = (id: string) => Cookies.set(unionKey, id)
export const getRouteName = () => Cookies.get(routeName)
export const setRouteName = (name: string) => Cookies.set(routeName, name)
export const removeId = () => Cookies.remove(unionKey)
